import React from 'react';
import { Link } from 'react-router-dom';
import { HiOutlineArrowLeft } from 'react-icons/hi2';

const TermsPage = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <div className="bg-white shadow-sm border-b">
        <div className="max-w-4xl mx-auto px-4 py-6">
          <div className="flex items-center">
            <Link 
              to="/" 
              className="flex items-center text-gray-600 hover:text-gray-900 transition-colors mr-6"
            >
              <HiOutlineArrowLeft className="w-5 h-5 mr-2" />
              Back to Home
            </Link>
            <h1 className="text-2xl font-bold text-gray-900 font-heading">
              Terms & Conditions
            </h1>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-4 py-12">
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-8 lg:p-12">
          {/* Last Updated */}
          <div className="mb-8 pb-6 border-b border-gray-200">
            <p className="text-sm text-gray-500 font-sans">
              Last updated on Aug 17 2025
            </p>
          </div>

          {/* Introduction */}
          <div className="mb-8">
            <p className="text-gray-700 leading-relaxed font-sans mb-4">
              For the purpose of these Terms and Conditions, The term "we", "us", "our" used anywhere on this page shall mean <strong>DEEPAK KUMAR</strong>, whose registered/operational office is <strong>104, Building No. - 15, Celebration KH4, Sector- 17, Kharghar Raigarh MH MAHARASHTRA 410210</strong>. "you", "your", "user", "visitor" shall mean any natural or legal person who is visiting our website and/or agreed to purchase from us.
            </p>
            <p className="text-gray-700 leading-relaxed font-sans">
              Your use of the website and/or purchase from us are governed by following Terms and Conditions:
            </p>
          </div>

          {/* Terms List */}
          <div className="space-y-6">
            <div className="flex items-start">
              <div className="flex-shrink-0 w-2 h-2 bg-blue-500 rounded-full mt-3 mr-4"></div>
              <p className="text-gray-700 leading-relaxed font-sans">
                The content of the pages of this website is subject to change without notice.
              </p>
            </div>

            <div className="flex items-start">
              <div className="flex-shrink-0 w-2 h-2 bg-blue-500 rounded-full mt-3 mr-4"></div>
              <p className="text-gray-700 leading-relaxed font-sans">
                Neither we nor any third parties provide any warranty or guarantee as to the accuracy, timeliness, performance, completeness or suitability of the information and materials found or offered on this website for any particular purpose. You acknowledge that such information and materials may contain inaccuracies or errors and we expressly exclude liability for any such inaccuracies or errors to the fullest extent permitted by law.
              </p>
            </div>

            <div className="flex items-start">
              <div className="flex-shrink-0 w-2 h-2 bg-blue-500 rounded-full mt-3 mr-4"></div>
              <p className="text-gray-700 leading-relaxed font-sans">
                Your use of any information or materials on our website and/or product pages is entirely at your own risk, for which we shall not be liable. It shall be your own responsibility to ensure that any products, services or information available through our website and/or product pages meet your specific requirements.
              </p>
            </div>

            <div className="flex items-start">
              <div className="flex-shrink-0 w-2 h-2 bg-blue-500 rounded-full mt-3 mr-4"></div>
              <p className="text-gray-700 leading-relaxed font-sans">
                Our website contains material which is owned by or licensed to us. This material includes, but are not limited to, the design, layout, look, appearance and graphics. Reproduction is prohibited other than in accordance with the copyright notice, which forms part of these terms and conditions.
              </p>
            </div>

            <div className="flex items-start">
              <div className="flex-shrink-0 w-2 h-2 bg-blue-500 rounded-full mt-3 mr-4"></div>
              <p className="text-gray-700 leading-relaxed font-sans">
                All trademarks reproduced in our website which are not the property of, or licensed to, the operator are acknowledged on the website.
              </p>
            </div>

            <div className="flex items-start">
              <div className="flex-shrink-0 w-2 h-2 bg-blue-500 rounded-full mt-3 mr-4"></div>
              <p className="text-gray-700 leading-relaxed font-sans">
                Unauthorized use of information provided by us shall give rise to a claim for damages and/or be a criminal offense.
              </p>
            </div>

            <div className="flex items-start">
              <div className="flex-shrink-0 w-2 h-2 bg-blue-500 rounded-full mt-3 mr-4"></div>
              <p className="text-gray-700 leading-relaxed font-sans">
                From time to time our website may also include links to other websites. These links are provided for your convenience to provide further information.
              </p>
            </div>

            <div className="flex items-start">
              <div className="flex-shrink-0 w-2 h-2 bg-blue-500 rounded-full mt-3 mr-4"></div>
              <p className="text-gray-700 leading-relaxed font-sans">
                You may not create a link to our website from another website or document without <strong>DEEPAK KUMAR</strong>'s prior written consent.
              </p>
            </div>

            <div className="flex items-start">
              <div className="flex-shrink-0 w-2 h-2 bg-blue-500 rounded-full mt-3 mr-4"></div>
              <p className="text-gray-700 leading-relaxed font-sans">
                Any dispute arising out of use of our website and/or purchase with us and/or any engagement with us is subject to the laws of India.
              </p>
            </div>

            <div className="flex items-start">
              <div className="flex-shrink-0 w-2 h-2 bg-blue-500 rounded-full mt-3 mr-4"></div>
              <p className="text-gray-700 leading-relaxed font-sans">
                We, shall be under no liability whatsoever in respect of any loss or damage arising directly or indirectly out of the decline of authorization for any Transaction, on Account of the Cardholder having exceeded the preset limit mutually agreed by us with our acquiring bank from time to time.
              </p>
            </div>
          </div>

          {/* Contact Information */}
          <div className="mt-12 pt-8 border-t border-gray-200">
            <h3 className="text-lg font-semibold text-gray-900 mb-4 font-heading">
              Contact Information
            </h3>
            <div className="bg-gray-50 rounded-lg p-6">
              <p className="text-gray-700 font-sans">
                <strong>Company:</strong> DEEPAK KUMAR<br />
                <strong>Address:</strong> 104, Building No. - 15, Celebration KH4, Sector- 17, Kharghar Raigarh MH MAHARASHTRA 410210<br />
                <strong>For any queries regarding these terms:</strong> Please contact us through our <Link to="/contact" className="text-blue-600 hover:text-blue-800 underline">Contact Us</Link> page.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsPage;
